// eslint-disable-next-line no-unused-vars
import * as React from 'react';
import { makeStyles } from '@mui/styles';
import {
  Card, CardContent, Chip, Divider, Typography,
} from '@mui/material';
import parse from 'html-react-parser';
import clsx from 'clsx';
import { AutoStories, BugReport } from '@mui/icons-material';
import { WorkItem } from './Types';

interface Props {
  wi: WorkItem;
}

const useStyles = makeStyles({
  divider: {
    marginBottom: 10,
    marginTop: 5,
  },
  paddingTop: {
    paddingTop: 10,
  },
  subtitle: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  flexBoxTitle: {
    display: 'flex',
    flexDirection: 'row',
    '& p > div': {
      display: 'inline-block',
    },
  },
  icon: {
    marginTop: 5,
    height: 20,
    marginRight: 5,
  },
  bugIcon: {
    color: '#7d232a',
  },
  storyIcon: {
    color: '#234f91',
  },
  table: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    columnGap: 25,
  },
  cell: {
    textAlign: 'left',
    '&:nth-child(2n)': {
      color: '#ff0000',
    },
  },
});

export default function WorkItemDetail(props: Props) {
  const { wi } = props;
  const classes = useStyles();

  const getFormattedDate = React.useCallback((timeStamp: number) => {
    const date = new Date(timeStamp);
    return `${date.getFullYear()}-${
      date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`
    }-${date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`}`;
  }, []);

  return (
    <Card>
      <CardContent>
        <div className={classes.flexBoxTitle}>
          <div>
            {wi.type === 'Bug' ? (
              <BugReport className={clsx(classes.icon, classes.bugIcon)} />
            ) : (
              <AutoStories className={clsx(classes.icon, classes.storyIcon)} />
            )}
          </div>
          <div className={classes.flexBoxTitle}>
            <Typography sx={{ fontSize: 20 }}>{`${wi.id}:`}</Typography>
            &nbsp;
            <Typography sx={{ fontSize: 20 }}>{parse(wi.title)}</Typography>
          </div>
        </div>

        <Divider className={classes.divider} />

        <div className={classes.table}>
          <div className={classes.cell}>Product Line:</div>
          <div className={classes.cell}>{wi.productLineDisplayName}</div>
          <div className={classes.cell}>Reported version:</div>
          <div className={classes.cell}>{wi.reportedVersion}</div>
          {wi.version !== '-' && (
            <>
              <div className={classes.cell}>Integrated version:</div>
              <div className={classes.cell}>{wi.version}</div>
            </>
          )}
          <div className={classes.cell}>Release Date:</div>
          <div className={classes.cell}>{getFormattedDate(wi.date)}</div>
        </div>

        <Divider className={classes.divider} />
        {wi.tags.length > 1 && wi.useTags === true && (
          <Typography className={clsx(classes.paddingTop, classes.subtitle)}>Tags</Typography>
        )}
        <div className={classes.paddingTop}>
          {wi.tags.length >= 2 && wi.useTags === true
            ? wi.tags
              .split('; ')
              .map((x) => (
                <Chip
                  style={{ marginRight: 5 }}
                  key={wi.id}
                  label={x.trim()}
                  variant="outlined"
                />
              ))
            : ''}
        </div>
      </CardContent>
    </Card>
  );
}
